// Label.js
import { getFirestore, updateDoc, collectionGroup, doc, setDoc, getDoc, collection, getDocs } from 'firebase/firestore';
import { app } from '../../firebaseConfig';
import { createRateQuery, getAvailableCarriers, getCourierDetails, mapStateToCode, enviaGenerateOrder } from '../cart/Utils';
const db = getFirestore(app);

export const markOrderDelivered = async (userEmail, orderId) => {
  try {
    const orderRef = doc(db, 'Orders', userEmail, 'UserOrders', orderId);
    const orderSnap = await getDoc(orderRef);

    if (!orderSnap.exists()) {
      throw new Error('Order not found');
    }

    const deliveredAt = new Date().toISOString();
    const exchangeCloseDate = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString();
    const updatedData = {
      orderStatus: 'Delivered',
      deliveredAt,
      updatedAt: deliveredAt,
      exchange: {
        exchangeOpen: true,
        exchangeClose: exchangeCloseDate,
      },
    };

    await updateDoc(orderRef, updatedData);

    console.log(`✅ Order ${orderId} marked as Delivered`);
    console.log(`📦 Exchange window closes on: ${exchangeCloseDate}`);

    return true;
  } catch (error) {
    console.error('❌ Error marking order as delivered:', error.message);
    throw error;
  }
};
// Generate and save user order
export const generateOrder = async (orderDetails) => {

  console.log("orderDetails", orderDetails)
  try {
    const sortedItems = orderDetails.items.sort((a, b) => a.name.localeCompare(b.name));

    const orderData = {
      userEmail: orderDetails.userEmail,
      items: sortedItems.map(item => ({
        name: item.name,
        size: item.size,
        color: item.color,
        quantity: item.quantity,
        declaredValue: item.declaredValue
      })),
      shippingAddress: {
        fullName: orderDetails.address.fullName,
        phone: orderDetails.address.phone,
        house: orderDetails.address.house,

        street: orderDetails.address.street,
        houseno: orderDetails.address.number || '',
        district: orderDetails.address.district || '',
        city: orderDetails.address.city,
        state: orderDetails.address.state,
        postalCode: orderDetails.address.postalCode,
        country: orderDetails.address.country,
        email: orderDetails.address.email || orderDetails.userEmail,
        reference: orderDetails.address.reference || '',
      },
      totalPrice: orderDetails.totalPrice,
      paymentMethod: orderDetails.paymentMethod.toUpperCase(),
      trackingUrl: '',
      createdAt: new Date().toISOString(),
      orderStatus: 'Placed'
    };

    const orderId = Math.floor(1000000000 + Math.random() * 9000000000).toString();
    const userOrdersRef = collection(db, 'Orders', orderDetails.userEmail, 'UserOrders');
    await setDoc(doc(userOrdersRef, orderId), orderData);

    return { success: true, orderId };
  } catch (error) {
    console.error('❌ Error in generateOrder:', error.message);
    return { success: false, error };
  }
};

export const getAllOrders = async () => {
  try {
    const snapshot = await getDocs(collectionGroup(db, 'UserOrders'));

    const allOrders = [];

    snapshot.forEach(doc => {
      const data = doc.data();

      // Reconstruct the email from path: "Orders/{email}/UserOrders/{orderId}"
      const pathSegments = doc.ref.path.split('/');
      const userEmail = pathSegments[1]; // "Orders/{email}/UserOrders/{orderId}"

      allOrders.push({
        id: doc.id,
        userEmail,
        ...data
      });
    });

    console.log('✅ All Orders:', allOrders);
    return allOrders;
  } catch (error) {
    console.error('❌ Error fetching all orders:', error.message);
    return [];
  }
};
export const updateOrderStatus = async (userEmail, orderId, newStatus, trackingId) => {
  try {
    const orderRef = doc(db, 'Orders', userEmail, 'UserOrders', orderId);
    await updateDoc(orderRef, {
      orderStatus: newStatus,
      trackingId: trackingId || null, // Store trackingId in Firestore
      updatedAt: new Date().toISOString(), // Optional: Track when the status was updated
    });
    console.log(`✅ Order ${orderId} status updated to ${newStatus} with tracking ID ${trackingId}`);
  } catch (error) {
    console.error('❌ Error updating order status:', error.message);
    throw error; // Re-thCrate an error to handle it appropriately
  }
};

